import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: HTMLDivElement
}

export const NotificationDot: TOC<Signature> = <template>
  <div class="inline-block h-1.5 w-1.5 shrink-0 grow-0 rounded-full bg-pink-300" ...attributes></div>
</template>
